import axios from 'axios';
import { req, alipayReq, ztreq,bolbreq,forumreq, fileUploadReq } from './axiosFun';
import Vue from 'vue';

// 查询IM消息盒子
export const messageInfo = (params) => { return req("get", "/im/messagebox", params) };
// 查询历史协议
export const historyagreement = (params) => { return req("post", "/custom/xunyou/api/agreement/privacy/list", params) }


// 登录
export const login = (params) => { return req("post", "/api/login", params) };
// 正泰登录
export const ztlogin = (params) => { return req("post", "/zt/user/api/loginPhone", params) };
//上传
export const uploadfiles = (params) => { return bolbreq("post", "/common/upload", params) };

// 注册 - 获取短信验证码
// export const sendSms = (params) => { return req("get", "/common/sendSms", params) };

//查询账户是否已注册
export const getUserInfo = (params) => { return req("post", "/zt/service/user/api/getUserInfo", params) };
//查询账默认头像
export const getdetaultlogo = (params) => { return req("post", "/custom/xunyou/dImageInformation/api/list", params) };
// 获取logo
export const getlogo = (params) => { return req("get", "/zt/common/api/logos", params) };
// 介绍页安卓下载
export const androiddown = (params) => { return bolbreq("get", "/portal/pc/app/download", params) };
// 获取二维码
export const getqrcode = (params) => { return req("get", "/portal/pc/app/download/qr/list", params) };
// 获取招标列表
export const getBiddingList = (params) => { return ztreq("post", "/zt/service/bids/api/show/list", params) };
// 新增公告
export const addNotice = (params) => { return ztreq("post", "/zt/service/bids/api/user/publish", params) };
// 编辑公告
export const editNotice = (params) => { return ztreq("post", "/zt/service/bids/api/user/edit", params) };

// export function androiddown(params) {
//     return axios({
//         method: 'get',
//         url: baseUrl +  '/portal/pc/app/download',
//         params,
//         responseType: 'arraybuffer'
//     });
// }

export const sendSms = (params) => {return req("get", `/common/sendSms?TemplateCode=${params.TemplateCode}&phoneNumbers=${params.phoneNumbers}`, params)
    // return axios.get(`${Vue.prototype.$baseUrl}/center/common/sendSms?TemplateCode=${params.TemplateCode}&phoneNumbers=${params.phoneNumbers}`)
};

// 注册提交表达
export const register = (params) => { return req("post", "/custom/xunyou/api/registerPhone", params) };
// 之前的注册协议
export const registerBook = (params) => { return req("post", "/custom/xunyou/protocol/api/list", params) };
// 注册协议
export const userAgreement = (params) => { return req("post", "/custom/xunyou/api/app/agreement", params) };
//正泰注册
export const ztRegister = (params) => { return req("post", "/zt/user/api/registerPhone", params) };
// export const ztRegister = (params) => { return req("post", `/zt/user/api/registerPhone?establish="${params.establish}"&type=${params.type}&username=${params.username}
// &phone=${params.phone}&SocialCreditCode=${params.SocialCreditCode}&companyName=${params.companyName}&companyAddress=${params.companyAddress}&businessLicense=${params.businessLicense}&companyPhone=${params.companyPhone}&enterpriseMail=${params.enterpriseMail}
// &password=${params.password}&password_confirm=${params.password_confirm}&platForm=${params.platForm}&data=${params.data}&registeredFund=${params.registeredFund}&totalStaff=${params.totalStaff}&manage=${params.manage}&area=${params.area}
// &name=${params.name}&bizs="${params.bizs}"&qualification=${params.qualification}`, params) };

//正泰注册升级
export const ztUpRegister = (params) => { return req("post", "/zt/service/apply/api/user/change", params) };

//正泰注册升级修改
export const ztUpEditRegister = (params) => { return req("post", "/zt/service/api/editAccountApply", params) };

//未登录  忘记密码 ---
export const forgotPwd = (params) => { return req("post", "/custom/xunyou/api/forgotPwd", params) };
//不需要原密码直接修改用户密码 ---
export const resetPassword = (params) => { return req("post", "/custom/xunyou/api/resetPassword", params) };

// 忘记密码 --- 检测账户是否存在
export const checkloginPhone = (params) => { return req("get", `/custom/xunyou/api/checkloginPhone?phone=${params.phone}`, params) };
// 忘记密码 --- 短信校验
export const querySendDetails = (params) => { return req("post", "/common/querySendDetails", params) };

// 修改支付密码
export const editPayPasw = (params) => { return req("post", "/portal/editPayPasw", params) };

// 为你推荐 /custom/xunyou/commodity/api/recommend/commoditylist
export const recommendFavorit = (params) => { return req("post", "/custom/xunyou/commodity/api/recommend/commoditylist", params) };

// 支付接口
// /custom/xunyou/api/pay/alipay
// export const alipay = (params) => { return req("get", "/custom/xunyou/api/pay/alipay", params) };

// export const alipay = (params) => { console.log(params,params.notifyUrl,'支付参数'); return axios.get(`${Vue.prototype.$baseUrl}/custom/xunyou/api/pay/alipay?outTradeNo=${params.outTradeNo}&subject=${params.subject}&totalAmount=${params.totalAmount}&notifyUrl=${params.notifyUrl}`)};
export const alipay = (params) => { return axios.get(`${Vue.prototype.$baseUrl}/custom/xunyou/api/pay/alipay?outTradeNo=${params.outTradeNo}&subject=${params.subject}&totalAmount=${params.totalAmount}&notifyUrl=${params.notifyUrl}`) };
// 支付宝支付
export const alipayPc = (params) => { return alipayReq("post", `${Vue.prototype.$payUrl}/pay/alipay/pc`, params) }; // "http://122.51.226.11:18080/pay/alipay/pc"  `${Vue.prototype.$payUrl}/pay/alipay/pc`
// 微信支付
export const alipayPcWX = (params) => { return alipayReq("post", `${Vue.prototype.$payUrl}/pay/wechat/scan`, params) }; //"http://122.51.226.11:18080/pay/wechat/scan"  `${Vue.prototype.$payUrl}/pay/wechat/scan`

//  查询支付状态
export const payStatus = (params) => { return req("post", "/custom/xunyou/api/pay/alipayQuery", params) };

export const xy_personvalue = (params) => { return req("post", "/custom/xunyou/xy_personvalue/api/deal", params) };

// 获取余额支付比例
export const getBalancePayProportion = (params) => { return req("get", "/portal/api/getBalancePayProportion", params) };

// 正泰网银支付
export const getZtPay = (params) => { return req("post", "/zt/api/kjt/bank/pay", params) };

// 正泰支付包支付
export const getZtAlipayPcPay = (params) => { return req("post", "/zt/api/kjt/aggregate/pay", params) };

// `${Vue.prototype.$baseUrl}/portal/pc/add_order`

/**
 * 订单管理-交易订单
 **/
// 红包查询
export const redEnvelope = (params) => { return req("post", "/custom/xunyou/api/redlist", params) };
// 红包领取
export const getredEnvelope = (params) => { return req("post", "/custom/xunyou/red_envelopes_record/api/add", params) };
// 我领取的红包y
export const getMyred = (params) => { return req("post", "/custom/xunyou/red_envelopes_record/api/list", params) };

//用户角色状态
export const getUserAccountApplyStatus = (params) => { return req("post", "/zt/service/api/getUserAccountApplyStatus", params) };

// 商家入驻图片
export const pageConfigImg = (params) => { return req("post", "/custom/xunyou/page_config/api/list", params) };
// 商家入驻协议内容
export const agreementContent = (params) => { return req("post", "/custom/xunyou/mDescription/api/list", params) };

// 商家入驻欢迎页面下三个tabs
export const agreementThreelist = (params) => { return req("post", "/portal/agreementlist", params) };
// 商家入驻状态
export const getMercharntStep = (params) => { return req("post", "/portal/pc/getMercharntStep", params) };

// 商家入驻状态查询
export const getMercharntStatus = (params) => { return req("post", "/portal/pc/getMercharntStatus", params) }; //返回结果的状态1.审核中，2.审核通过

//zt商家入驻 申请表单
export const registration = (params) => { return ztreq("post", "/zt/api/kjt/merchant/registration", params) };

//zt商家入驻 补充完整信息申请表单
export const addBeneficiary = (params) => { return ztreq("post", "/zt/api/kjt/merchant/addBeneficiary", params) };


// 商家入驻是否支付保证金
export const payMargin = (params) => { return req("post", "/portal/pc/getMarginStatus", params) }; //返回结果的状态1.审核中，2.审核通过

// 商家入驻 申请表单
export const merchantForm = (params) => { return req("post", "/portal/mercharnt_add", params) };
// 商家入驻下拉框
// 店铺等级
export const slevelList = (params) => { return req("post", "/portal/slevelList", params) };
// 店铺分类
export const storeClasslist = (params) => { return req("post", "/custom/xunyou/classification/api/storeClasslist", params) };
// 店铺类目
export const leftmenu = (params) => { return req("get", "/portal/mainproduct", params) };
// 公司地址下拉框
export const area_list = (params) => { return req("post", "/portal/area_list", params) };
// 商家入驻付费清单
export const merchants_pay_list = (params) => { return req("post", "/portal/pc/merchants_pay_list", params) };
// 重新申请商家入驻
export const reApplyApi = (params) => { return req("post", "/portal/pc/reApply", params) };
// 重新申请并回显数据
export const reEmitApi = (params) => { return req("post", "/zt/service/merchant/api/getMerchantInfo", params) };
// 重新发起申请
export const MerchantInfo = (params) => { return req("post", "/zt/service/merchant/api/updateMerchantInfo", params) };

// 查询保证金是否开启
export const openMargin = (params) => { return req("get", "/custom/xunyou/margin/api/queryMarginMoneySwitch", params) };

// 查询保证金
export const checkMargin = (params) => { return req("get", `/custom/xunyou/margin/api/queryMarginMoney/${params.bxscId}`, params) };

//新增保证金记录
export const addMargin = (params) => { return req("post", "/custom/xunyou/margin/api/add", params) };

// 商家入驻-合同签订及缴费
export const merchantpayMoney = (params) => { return req("post", "/custom/xunyou/merchant/api/merchantedit", params) };

// 品牌
export const brandListApi = (params) => { return req("post", "/portal/brandlist", params) };

// 查询购物车接口
export const shoppingCartlist = (params) => { return req("post", "/portal/cartlist", params) };
// 添加购物车
export const addShoppingCart = (params) => { return req("post", "/custom/xunyou/cart/api/shoppingCart/add", params) }; // 待检测
// 购物车中删除
export const shoppingCartDelete = (params) => { return req("post", "/custom/xunyou/cart/api/shoppingCart/remove", params) }; // 待检测
// 购物车数量计算
export const editCartNumber = (params) => { return req("post", "/custom/xunyou/cart/api/edit", params) };


// 普通 -  商品列表  批发市场- 商品列表
export const commoditylist = (params) => { return req("post", "/custom/xunyou/commodity/api/pcCommoditylist", params) }; // stype  店铺类型（1.供货商|2.普通）
//首页到分类列表页的查询接口
// export const commoditylistClassify = (params) => { return req("post", "/custom/xunyou/commodity/api/pcCommoditylist/by/backids", params) };
//热门商品查询接口
export const commoditylistHotsale = (params) => { return req("post", "/custom/xunyou/commodity/api/pcCommoditylist/hotsale", params) };
export const commoditylistSupplie = (params) => { return req("post", "/custom/xunyou/commodity/api/commoditylistSupplie", params) }; // stype  店铺类型（1.供货商|2.普通）
// 首页分类点击过去查询商品列表
export const commoditylistForSecondCategory = (params) => { return req("post", "/custom/xunyou/commodity/api/commoditylistForSecondCategory", params) }; // stype  店铺类型（1.供货商|2.普通）
// 批发市场 == 首页分类点击过去查询商品列表
export const merchantCommoditylistForSecondCategory = (params) => { return req("post", "/custom/xunyou/commodity/api/merchantCommoditylistForSecondCategory", params) }; // stype  店铺类型（1.供货商|2.普通）

// 查询商品详情
export const commodityDetails = (params) => { return req("post", "/custom/xunyou/commodity/api/commoditylist_details", params) };
// 获取商品规格
export const getAttributelist = (params) => { return req("post", "/custom/xunyou/bg_specification_details/api/getAttributelist", params) };
// /custom/xunyou/bg_specification_details//getAttributelist
// 点击商品规格，获取相应的价格
export const getSpecificationDetail = (params) => { return req("post", "/custom/xunyou/bg_specification_details/api/getSpecificationDetail", params) };
// 点击商品规格，获取规格
export const getSpecificationselect = (params) => { return req("post", "/custom/xunyou/bg_specification_details/api/getSpecificationselect", params) }; //specificationId
// /custom/xunyou/bg_specification_details//getAttributelist
// 查询店铺评价
export const score = (params) => { return req("post", "/custom/xunyou/order_evaluation/api/score", params) };

// /api/getSpecificationselect

// 商品列表分类
export const categorylist = (params) => { return req("post", "/custom/xunyou/category/api/categorylist", params) };

// 正泰商品列表分类
export const frontCategory = (params) => { return req("post", "/zt/service/front/category/api/frontCategory", params, true) };


// 商品详情页面
// export const categorylist = (params) => { return req("post", "/custom/xunyou/category/api/categorylist", params) };
// 商品咨询
export const goodsAdvice = (params) => { return req("post", "/custom/xunyou/advisory/api/list", params) };
// 商品咨询----提问
export const addgoodsAdvice = (params) => { return req("post", "/custom/xunyou/advisory/api/add", params) };



// 批发市场- 商品列表 查询商品状态
// 0.未签约 1.审核中 2.签约通过 3.审核驳回 4.商品未签约 5.已经分销 6.一键分销
export const getDistStatus = (params) => { return req("post", "/portal/pc/getDistStatus", params) };
// 申请成为分销商
export const distributors_add = (params) => { return req("post", "/portal/pc/distributors_add", params) };
// 一键分销
export const WholesaleGoods_add = (params) => { return req("post", "/portal/pc/WholesaleGoods_add", params) };





// 订单详情页面（地址增删改查）
// 地址查询
export const addresslist = (params) => { return req("post", "/custom/xunyou/user_address/api/addresslist", params) };
// 增加地址
export const address_add = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/add", params) };
// 删除地址
export const address_remove = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/remove", params) };
// 修改地址
export const address_saveedit = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };
// 查询店铺运费信息
// export const getStoreFreight = (params) => { return req("post", "/portal/pc/getStoreFreight", params) };
export const getStoreFreight = (params) => {
    // return axios.post("http://127.0.0.1/portal/pc/add_order", params)
    return axios.post(`${Vue.prototype.$baseUrl}/portal/pc/getStoreFreight`, params)
};

// /portal/pc/getStoreFreight
// 提交订单
// export const addOrder = (params) => { return req("post", "/portal/add_order", params) };
export const addOrder = (params) => {
    return axios.post(`${Vue.prototype.$baseUrl}/portal/pc/add_order`, params)
};

// 通过 立即购买按钮 跳转过来 下单的接口
export const immediatePlaceOrder = (params) => {
    return axios.post(`${Vue.prototype.$baseUrl}/portal/pc/immediatePlaceOrder`, params)
};

// 跳到下单详情页面前，掉这个接口
export const get_order = (params) => { return req("post", "/get_order", params) };
// 下单后显示订单
export const showorderList = (params) => { return req("post", "/portal/pc/orderVoList", params) };
// 查询订单详情
export const showorderDetail = (params) => { return req("post", "/portal/pc/orderDetails", params) };
// 下单时的校验
export const checkPay = (params) => { return req("post", "/portal/pc/checkPay", params) };

// 积分订单查询
export const pointList = (params) => { return req("post", "/custom/xunyou/xy_order/api/pointList", params) };


/** 我的订单 **/
// 搜索
export const searchOrder = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };
// 我的订单查询
export const orderLists = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };
// 立即支付
export const payFor = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };
// 退款
// export const backMoney = (params) => { return req("get", "/custom/xunyou/api/pay/alipayRefund", params) };
export const backMoney = (params) => { return axios.get(`${Vue.prototype.$baseUrl}/custom/xunyou/api/pay/alipayRefund?out_trade_no=${params.out_trade_no}&refund_amount=${params.refund_amount}&out_request_no=${params.out_request_no}&refund_reason=${params.refund_reason}&goodsId=${params.goodsId}`) };
export const addbackMoney = (params) => { return req("post", "/custom/xunyou/after_sale/api/add", params) };
export const editbackMoney = (params) => { return req("post", "/custom/xunyou/after_sale/api/edit_after_sale", params) };
// 填写退货物流
export const returnDelivery = (params) => { return req("post", "/custom/xunyou/after_sale/api/returnDelivery", params) };
// 退款原因查询
export const getDictData = (params) => { return req("post", "/common/getDictData", params) };
// 退款列表
export const backMoneyList = (params) => { return req("post", "/custom/xunyou/after_sale/api/list", params) };
// /custom/xunyou/after_sale/api/list
// 撤销退款申请
export const remove_after_sale = (params) => { return req("post", "/custom/xunyou/after_sale/api/remove_after_sale", params) };
// 退款金额查询
export const returnAmount = (params) => { return req("get", `/custom/xunyou/after_sale/api/returnAmount?oid=${params.oid}&bxysid=${params.bxysid}`, params) };

// 取消订单
export const cancleOrderItem = (params) => { return req("post", "/portal/pc/cancelOrder", params) };
// 移除订单
export const removeOrderItem = (params) => { return req("post", "/portal/pc/removeOrder", params) };
// 确认收货
export const confirmRceiptItem = (params) => { return req("post", "/portal/order_End", params) };
// 物流查询
export const kuaidi100 = (params) => { return req("get", `/custom/xunyou/api/kuaidi/kuaidi100?tracking_num=${params.tracking_num}&logistics_name=${params.logistics_name}`, params) };
// 订单物流查询（多个包裹）
export const logisticsQuery = (params) => { return req("get", `/custom/xunyou/logistics/api/logisticsQuery?orderId=${params.orderId}`, params) };


// 查看订单详情
export const orderDetailItem = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };

/** 关注中心 **/
// 我的足迹
export const footprint_list = (params) => { return req("post", "/custom/xunyou/footprint/api/footprint_list", params) };
// 商品/店铺收藏
export const collection_list = (params) => { return req("post", "/custom/xunyou/collectionMG/api/collection_list", params) }; //type:1:商品；2：店铺；
// 添加收藏
export const addCollection = (params) => { return req("post", "/custom/xunyou/collectionMG/api/addCollection", params) }; //type:1:商品；2：店铺；
// 取消收藏
export const removeCollection = (params) => { return req("post", "/custom/xunyou/collectionMG/api/removeCollection", params) }; //type:1:商品；2：店铺；

/** 个人中心 **/
// 我的信息
export const userDetails = (params) => { return req("get", `/portal/userDetails/${params.userId}`, params) };

// 发票管理
export const userInvoice = (params) => { return req("post", "/zt/service/userInvoice/api/list", params) };
// 抬头管理
export const getInvoiceTitle = (params) => { return req("post", "/zt/service/invoice/api/getInvoiceTitle", params) };
// 新增抬头管理
export const addInvoiceTitle = (params) => { return req("post", "/zt/service/invoice/api/addInvoiceTitle", params) };
// 修改抬头管理
export const updateInvoiceTitle = (params) => { return req("post", "/zt/service/invoice/api/updateInvoiceTitle", params) };
// 删除发票抬头
export const delInvoiceTitle = (params) => { return req("post", "/zt/service/invoice/api/delInvoiceTitle", params) };
// 新增意见反馈
export const addSuggest = (params) => { return req("post", "/zt/service/suggest/api/addSuggest", params) };
// 新增意见反馈
export const getSuggestList = (params) => { return req("post", "/zt/service/suggest/api/getSuggestList", params) };
// 意见反馈详情
export const getSuggestById = (params) => { return req("post", "/zt/service/suggest/api/getSuggestById", params) };


//账户信息编辑
export const editUser = (params) => { return req("post", '/portal/editUser', params) };
//已登录 -- 修改密码
export const resetPwd = (params) => { return req("post", "/custom/xunyou/api/resetPwd", params) };

/** 财产中心 */
export const integralList = (params) => { return req("post", "/custom/xunyou/integral/api/list", params) };


// 交易订单-s删除交易订单
// export const OrderDelete = (params) => { return axios.delete("/api/Order/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
/**
 * 首页
 */

// 顶部热门搜索
export const hot_search = (params) => { return req("post", "/custom/xunyou/api/hot_search", params) };
// 顶部默认搜索
export const search_list = (params) => { return req("post", "/custom/xunyou/api/search_list", params) };

//轮播图
export const swiperList = (params) => { return req("post", "/custom/xunyou/promotion/api/swiperlist", params) };

//热门分类图
export const categoryHotList = (params) => { return req("post", "/portal/storeCategoryHot_list", params) };

//菜单
export const navList = (params) => { return req("post", "/portal/navlist", params) };

//左侧菜单
export const leftMenuList = (params) => { return req("get", "/portal/leftmenu", params) };

// 通知
export const noticeList = (params) => { return req("post", "/custom/xunyou/api/articleList", params) };

/**
 * 店铺街
 */
//店铺列表
export const storerList = (params) => { return req("post", "/portal/pc/merchantlist", params) };
// 查询店铺入住状态
export const storerSettled = (params) => { return req("post", "/portal/pc/merchantlist/settled", params) };

//店铺列表
export const merchantlistSupplie = (params) => { return req("post", "/portal/pc/merchantlistSupplie", params) };

//店铺搜索
export const toSearch = (params) => { return req("post", "/custom/xunyou/merchant/api/merchantlist", params) };

// 查询店铺的用户管理
export const imUserID = (params) => { return req("post", "/portal/pc/getImUserID", params) };

export const imFriends = (params) => { return req("post", "/custom/xunyou/im_friends/api/add", params) };
// 店铺页面 - 查询店铺轮播图
export const storeSwiperList = (params) => { return req("post", "/custom/xunyou/store_mg/store/store_info/api/list", params) };
// 店铺页面 - 查询店铺分类(內)列表
export const storeCategory = (params) => { return req("post", "/custom/xunyou/sort/api/list", params) };


/** 支付中心 */
// 交易流水
export const payList = (params) => { return req("post", "/custom/xunyou/user_balance_flow/api/payList", params) };
// 余额流水查询
export const balanceTurnover = (params) => { return req("post", "/custom/xunyou/user_balance_flow/api/list", params) };
// 点击充值 recharge
export const recharge = (params) => { return req("post", "/portal/pc/merchantlist", params) };

/** 用户中心 */
// 账号绑定-实名认证
export const queryUserStatus = (params) => { return req("post", "/portal/queryUserStatus", params) };
// 账号绑定-手机绑定
export const bindingPhone = (params) => { return req("post", "/portal/bindingPhone", params) };
// 账号绑定-邮箱绑定
// export const bindingEmail = (params) => { return req("post", "/portal/bindingEmail", params) };
//  账号绑定-发送邮箱验证码
export const sendEmail = (params) => { return req("get", `/common/sendEmail?email=${params.email}`, params) };
//  账号绑定-邮箱验证码校验
export const vEmail = (params) => { return req("post", '/common/vEmail', params) };
// 账号绑定-实名认证
export const authentication = (params) => { return req("post", "/portal/authentication", params) };

/**  客户服务  * */
// 文章分类列表
export const article_category_list = (params) => { return req("post", "/portal/article_category_list", params) };
// 文章（和公告）列表接口
export const helpArticle_list = (params) => { return req("post", "/portal/helpArticle_list", params) };
// 文章（和公告）详情
export const helpArticle_details = (params) => { return req("get", `/portal/helpArticle_details/${params.articleId}`, params) };

//pc首页底部文字列表2021-07-03
export const bottom_article_list = (params) => { return req("post", "/portal/bottom_article_list", params) };
// 个人账户汇总
export const getUserPay = (params) => { return req("get", `/custom/xunyou/api/getUserPay/${params.userId}`, params) };



/** 评论 */
// 待评论列表
export const evaluateCommodityList = (params) => { return req("post", "/custom/xunyou/evaluation/api/evaluateCommodityList2", params) };
// 待评论列表
export const evaluateOrderList = (params) => { return req("post", "/portal/pc/api/orderList", params) };
// 评论列表
export const commentList = (params) => { return req("post", "/custom/xunyou/evaluation/api/list", params) };
// 发表评论
export const postComment = (params) => { return req("post", `/custom/xunyou/evaluation/api/add`, params) };
// zt发表评论
export const ztPostComment = (params) => { return ztreq("post", `/custom/xunyou/evaluation/api/app/add`, params) };
// 回复评论
export const replayComment = (params) => { return req("post", `/custom/xunyou/deal_order_evaluation_reply/api/add`, params) };
// 删除评论
export const deleteComment = (params) => { return req("post", `/custom/xunyou/evaluation/api/remove`, params) };

// 商品评价详情
export const findEvaluation = (params) => { return req("post", "/custom/xunyou/evaluation/api/findEvaluation", params) };

/** 资金 */
// 充值卡校验是否存在
export const checkcard = (params) => { return req("post", "/portal/checkcard", params) };
// 充值卡充值
export const rechargeCard_recharge = (params) => { return req("post", "/portal/rechargeCard_recharge", params) };
// 充值卡流水列表
export const recharge_card_turnover = (params) => { return req("post", "/custom/xunyou/recharge_card_turnover/api/list", params) };
// // 余额支付API
export const balancePay = (params) => { return req("post", "/portal/balancePay", params) };

// 混合支付
export const balancePayMax = (params) => { return req("post", "/portal/balancepay_max", params) };

/* 积分商城 */
export const presentlist = (params) => { return req("post", "/custom/xunyou/points_exchange/api/presentlist", params) };

/* 限时折扣 */
// activityTypeId=2 2折扣 6秒杀
export const activityCommodityList = (params) => { return req("post", "/custom/xunyou/commodity/api/activityCommodityList", params) };

/* 秒杀 */
export const seckillCommodityList = (params) => { return req("post", "/custom/xunyou/commodity/api/seckillCommodityList", params) };
// /center/custom/xunyou/commodity/api/seckillCommodityList

/** 首页 */
// 装修接口
// export const getPage = (params) => {return req("get", `/custom/xunyou/api/getPage?id=${params.id}`, params) };
export const getPage = (params) => { return req("get", `/portal/pc/getPcPage?id=${params.id}`, params) };

/* 改造后的接口 */
// 商品列表
export const commodities = (params) => { return req("get", "/center/rest-apis/commodities", params) };

/** 文章评价 */
//新增评论接口
export const addChat = (params) => { return req("post", "/custom/xunyou/context/api/add", params) }
    // 查询评论列表
export const getChat = (params) => { return req("post", "/custom/xunyou/context/api/list", params) }
    // 渲染店铺入驻协议
export const shopPass = (params) => { return req("post", "/custom/xunyou/description/api/list", params) }
    // 版权名称可配
export const copyRight = (params) => { return req("post", "/custom/xunyou/information/api/list", params) }
    // 自定义图片设置
export const setImage = (params) => { return req("post", "/custom/xunyou/imageInformation/api/list", params) }
    // 查询快递公司接口 /custom/xunyou/express_delivery/api/list
export const getCompany = (params) => { return req("post", `/custom/xunyou/express_delivery/api/${params.id}`, params) }
    // 查询平台所有的快递公司
export const getAllCompany = (params) => { return req("post", `/custom/xunyou/express_delivery/api/list`, params) }
    // 删除足迹
export const removefoot = (params) => { return req('post', '/custom/xunyou/footprint/api/removeFootprint', params) }

//覆盖规格价格
export const coveragePrice = (params) => { return req('post', '/custom/xunyou/bg_specification_details/api/getSpecificationDetailById', params) }

// 获取分类运维列表
export const getOperation = (params) => { return req('get', '/zt/service/category/api/categorylist', params) }
    // 获取运维分类下的店铺列表
export const getOperationshop = (params) => { return req('post', '/zt/service/store/api/getStoreListByCId', params) }
    // 查询电站类型
export const getOperationtype = (params) => { return req("get", '/zt/service/type/api/typeList', params) }

//招标公告详情
export const getBidsList = (params) => { return req("post", '/zt/service/bids/api/list', params) }

//提交业务联系
export const getServiceOrder = (params) => { return req("post", '/zt/service/order/api/addServiceOrder', params) }


//查询业务联系
export const getQueryOrderList = (params) => { return req("post", '/zt/service/order/api/queryOrderList', params) }

//查询业务联系详情
export const getQueryOrderInfo = (params) => { return req("post", '/zt/service/order/api/queryOrderInfo', params) }

//查询商品状态接口
export const getGoodsStatus = (params) => { return req("post", '/zt/service/commodity/api/getDetailById', params) }

//判断当前账号下是否包含店铺
export const shopStatus = (params) => { return req("post", '/zt/service/merchant/api/extisMerchant', params) }

//账号升级数据回显

export const accountUpgradeInfo = (params) => { return req("post", '/zt/service/api/queryAccountApply', params) }

//微信登录

export const wxLogin = (params) => { return req("get", `/zt/service/weixinAuth/api/pc_weixin_access_token?code=${params.code}`, params) }

//查看用户信息

export const getWxUserInfoByOpenId = (params) => { return req("post", '/custom/xunyou/api/getWxUserInfoByOpenId', params) }

//绑定微信

export const login_wx = (params) => { return req("post", '/custom/xunyou/api/login_wx', params) }

//宣传页

export const PcActivityPage = (params) => { return req("get", `/portal/pc/getPcActivityPage/${params.num}`, params) }
//省份字典
export const getProvince = (params) => { return req("post", '/custom/area/list', params) }
//业务字典
export const getBusiness = (params) => { return ztreq("post", '/system/dict/data/show/list', params) }
//登录名唯一判断
export const verificationName = (params) => { return req("post", '/zt/user/api/checkLoginNameUnique', params) }
//手机号唯一判断
export const verificationPhone = (params) => { return req("post", '/zt/user/api/checkPhoneUnique', params) }
//微信重新绑定
export const rebindWX = (params) =>{return req("post", `/zt/service/mall/account/wx/api/rebind`, params)}
//微信解绑
export const wxunbinding = (params) =>{return req("get", `/zt/service/mall/account/wx/api/unbind/${params.userId}`, params)}
//绑定邮箱
export const bindingEmail = (params) =>{return req("post", `/portal/editUser`, params)}



//店铺
//获取装修接口
export const getPcStorePage = (params) => { return req("get", `/portal/pc/getPcStorePage?storeId=${params.storeId}`, params) };



//论坛
//论坛首页分论坛列表
export const getBrief = (params) => { return forumreq("get", `/zt/biz/forum/api/main/page/branch/brief?loginName=${params.loginName}`, params) };
//论坛首页主题列表
export const moduleList = (params) => { return forumreq("get", `/zt/biz/forum/api/main/page/last/threads/stick/top?rowSize=${params.rowSize}&mainPageMode=${params.mainPageMode}`, params) };
//分论坛列表
export const getThreads = (params) =>{ return forumreq("get", `/zt/biz/forum/api/thread/pageList?fid=${params.fid}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`, params) };
//论坛帖子内容搜索/模糊搜索
export const forumSearch = (params) => { return forumreq("get", `/zt/biz/forum/api/main/page/search?keyWord=${params.keyWord}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`, params) };
//论坛主题帖子详情展示
export const threadShow = (params) => { return forumreq("get", `/zt/biz/forum/api/main/page/thread/show?pageNum=${params.pageNum}&pageSize=${params.pageSize}&tid=${params.tid}&showHide=${params.showHide}`, params) };
//获取我的帖子
export const postList = (params) => { return forumreq("get", `/zt/biz/forum/api/main/page/my/type/postList?
pageNum=${params.pageNum}&pageSize=${params.pageSize}&postStep=${params.postStep}&postType=${params.postType}&createBy=${params.createBy}`, params) };
//发布帖子
export const subInsert = (params) =>{ return ztreq("post", `/zt/biz/forum/api/post/insert`, params) };
//修改帖子
export const modifyPosting = (params) =>{ return ztreq("post", `/zt/biz/forum/api/post/updateById`, params) };
//楼内帖子回复
export const postingInsert = (params) =>{ return ztreq("post", `/zt/biz/forum/api/post/reply/insert`, params) };
//点赞
export const upLike = (params) => { return forumreq("get", `/zt/biz/forum/api/main/page/update/like?pid=${params.pid}&authorId=${params.authorId}&prid=${params.prid}`, params) };
//询价篮
export const InquiryBasketAdd = (params) =>{return ztreq("post", `/custom/xunyou/api/commodity/inquiry/cart/insert`, params)}
//获取询价篮列表
export const InquiryBasketList = (params) =>{return ztreq("get", `/custom/xunyou/api/commodity/inquiry/cart/shopGroupList?uid=${params.uid}`, params)}
//根据id删除单品
export const inquiryBasDeleteById = (params) =>{return ztreq("post", `/custom/xunyou/api/commodity/inquiry/cart/deleteById`, params)}
//批量删除
export const inquiryBasDeleteByIds = (params) =>{return ztreq("post", `/custom/xunyou/api/commodity/inquiry/cart/deleteByIdList`, params)}
//询价篮修改
export const inquiryBasUpdateById = (params) =>{return ztreq("post", `/custom/xunyou/api/commodity/inquiry/cart/updateById`, params)}
//创建询价单
export const inquiryCreate = (params) =>{return ztreq("post", '/custom/xunyou/commodity/api/inquiry/order/create', params)}
//查询询价单
export const inquiryOrderList = (params) =>{return ztreq("post", '/custom/xunyou/commodity/api/inquiry/order/list', params)}
//批量收藏接口
export const batchByList = (params) =>{return ztreq("post", '/custom/xunyou/collectionMG/api/addCollection/byList', params)}

//对外合作联合交易接口
//查询联合登录用户信息
export const uniteUserInfo = (params) =>{return ztreq("post", '/api/foreign/union/sys/token/user', params)}
//业务场景
export const getFloors = (params) => { return req("get", `/portal/pc/biz/scene/floors`, params) };
//首页热门推荐
export const recommendByPage = (params) =>{return req("post", '/custom/xunyou/commodity/api/recommend/commodity/page', params)}
//超级验证码
export const superCode = (params) =>{return req("post", '/zt/service/api/super/code', params)}
//集采专区（旧）
export const procurementList = (params) =>{return req("post", '/custom/xunyou/commodity/api/commodity/procurement/list', params)}
//集采专区（新）
export const procurementListNew = (params) =>{return ztreq("post", `/zt/purchaseCommodityGroup/api/pageList`, params)}
//获取区域配送信息
export const cargofInfo = (params) =>{return ztreq("post", '/custom/xunyou/commodity/api/commodity/cargo/info', params)}



// 赏金模块
// 根据类型获取任务商品分页列表
export const taskPicList = (params) =>{return ztreq("get", '/zt/biz/bizBountyTask/front/api/task/taskPicList', params)}
// PC端赏金任务页面列表
export const getTaskCommodityList = (params) =>{return ztreq("get", `/zt/biz/BountyTaskRel/front/api/getTaskCommodityList?type=${params.type}&taskId=${params.taskid}&pageNum=${params.pageNum}&pageSize=40&userId=${params.userId}`, params)}
// 获取当前赏金活动详情
export const getCurrentActivity = () =>{return ztreq("get", '/zt/biz/bizBountyTask/front/api/getCurrentActivity')}
// 新增主图或规格
export const addActivityFeedback = (params) =>{return ztreq("post", '/zt/biz/TaskFeedback/front/api/addActivityFeedback', params)}
// 获取最新的积分奖励
export const getLatestReward = () =>{return ztreq("get", '/zt/biz/TaskFeedback/front/api/getLatestReward')}
//通用上传请求——返回URL
export const fileUploadUrl = (params) => { return fileUploadReq("post", "/common/fileUploadUrl", params) };
// 获取用户赏金相关信息
export const getUserBountyInfo = (params) => { return ztreq('get',`/zt/biz/bizBountyUserPoint/front/api/getUserBountyInfo?userId=${params.userId}`, params) };
// 获取用户积分历史记录列表分页
export const getUserPointTradeList = (params) => { return ztreq('get',`/zt/biz/exchangerecord/front/api/pageList?customerId=${params.userId}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`, params) };
// 卡管理分页列表
export const exchangecardPageList = () => { return ztreq('get','/zt/biz/exchangecard/front/api/pageList?pageNum=1&pageSize=1000') };
// 兑换记录新增
export const exchangerecordInsert = (params) => { return ztreq('post','/zt/biz/exchangerecord/front/api/insert', params) };
// 获取用户积分历史记录列表分页
export const getMyUserPointTradeList = (params) => { return ztreq('get','/zt/biz/bizBountyPointHistory/front/api/getUserPointTradeList?userId=' + params.userId) };

// 2024-09-25：手机验证登录
export const loginPhone = (params) => {return req("post", '/custom/xunyou/api/loginPhone', params) }

//2025-0425
export const batchOrderTemplateDownload = (params) => {return ztreq("post", '/custom/xunyou/sanxia/api/batchOrderTemplate/download', params) }
export const batchOrder = (params) => {return fileUploadReq("post", '/custom/xunyou/sanxia/api/batchOrder', params) }
export const addBatch = (params) => {return ztreq("post", '/custom/xunyou/cart/api/shoppingCart/addBatch', params) }
export const downloadOrderDetail = (params) => {return req("post", '/custom/xunyou/evaluation/api/downloadOrderDetail', params) }
//saas获取区域
export const getSaasArea = (params) => { return req("get", "/zt/common/api/saas/saasArea/list", params) };
//省市数据
export const getSaasAreaList = (params) => { return req("get", `/zt/common/api/saas/saasAreaBind/list?userId=${params.userId}`, params) };
//获取清洗电站分页
export const getStationPage = (params) => { return req("get", `/zt/common/api/saas/station/page?cityCode=${params.cityCode}&provinceCode=${params.provinceCode}&name=${params.name}&pageNum=${params.pageNum}&pageSize=${params.pageSize}&userId=${params.userId}`, params) };
//获取清洗电站详情
export const getStationDetail = (params) => { return req("get", `/zt/common/api/saas/station/detail?stationCode=${params.stationCode}`, params) };
//获取电站清洗派单信息
export const getStationClean = (params) => { return req("get", `/zt/common/api/saas/station/clean-dispatch?stationCode=${params.stationCode}`, params) };
//获取电站组件污染物信息
export const getStationPollutant = (params) => { return req("get", `/zt/common/api/saas/station/pollutant?stationCode=${params.stationCode}`, params) };
//获取saas站点打点图或附件列表
export const getStationAttList = (params) => { return req("get", `/zt/common/api/station/attList?stationCode=${params.stationCode}&userId=${params.userId}&fileType=${params.fileType}`, params) };
//saas站点打点图或站点资料上传
export const picOrDocUpload = (params) => {return fileUploadReq("post", '/zt/common/api/station/picOrDocUpload', params) }
//清洗入口-电站准入
export const getCleanAccess = (params) => { return req("get", `/zt/common/api/saas/station/cleanAccess?uid=${params.uid}`, params) };

//关联商品查询
export const getProductRelList = (params) => { return req("get", `/zt/common/api/bizProductRelation/productRelList?productId=${params.productId}`, params) };
//关联商品准入
export const getRelListAccess = (params) => { return req("get", `/zt/common/api/bizProductRelation/relListAccess?uid=${params.uid}`, params) };
//获取京东省份
export const getjdAreaProvinceLists = (params) => { return req("post", `/portal/jd_area_province_list`) };
//获取下级省份
export const getjdAreaProvinceChild = (params) => { return req("post", `/portal/jd_area_children_by_parent`, params) };

//电站新增信息写入
export const addExtInfo = (params) => { return ztreq("post", `/zt/common/api/saas/saasStationBusinessExt/addExtInfo`, params) };

//拍照识图上传图片
export const uploadImageFiles = (params) => { return fileUploadReq("post", "/api/search/image/upload", params) };
//首次发起图片搜索
export const querySearchImage = (params) => { return req("post", "/api/search/image/query", params) };
//搜索结果翻页/排序
export const getSearchImageResultPage = (params) => { return req("post", "/api/search/image/result/page", params) };



// WEBPACK FOOTER //
// ./src/api/xunyou.js